<template>
  <!--<div class="logo" >-->
  <el-menu class="navbar" mode="horizontal" style="overflow: hidden">
    <!--图标-->
    <div class="left-menu"  @click="homeClick">
      <!--<hamburger class="left-menu-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>-->
      <svg-icon icon-class="navl-logo" style="cursor: pointer"  class-name='left-menu-logo' />
    </div>
    <sidebar class="sidebar-container"></sidebar>
    <div style="display: inline-block" v-if="badgeNub == 0" @click="viewAllClick">
      <svg-icon  icon-class="message" style="cursor: pointer"   class-name='left-menu-logo ' />
    </div>

    <div v-else style="display: inline-block">
      <el-popover
        placement="bottom"
        width="380"
        trigger="click"
        v-model="messageVisible"
      >
        <div class="mark-message">
          <div class="mark-message-title">
            <el-checkbox style="margin-right: 10px;"  v-model="allCheckd" @change="checkboxChange(2,selectEquipmentInfoList)">{{$t('information.allCoxRead')}}</el-checkbox></div>
          <div class="message-list">
            <transition-group enter-active-class="animated fadeIn" leave-active-class="animated bounceOutRight">
              <div class="message-list-item animated"  v-for="(item, index) in equipmentInfoList" v-bind:key="item.id"  v-show="!(item.id === currentIndex)" :class="messageActive == index ? 'message-list-item-active': ''" @click="messageClick(item,index)">
                <div class="message-list-item-cox">
                  <el-checkbox v-model="item.checkd"  @click.native.stop="" @change.native.stop="checkboxChange(1,item)"></el-checkbox>
                </div>
                <div class="message-list-item-content" v-if="item.code == 2609" @click.stop>
                  <div>
                    <div>
                       {{item.information.extra}}
                    </div>
                    <div>
                     {{$t('information._'+item.code)}}<a class="aActive" @click="codeClick(item)">{{$t('information._'+item.code+'_a')}}</a>{{$t('information._'+item.code+'_time')}}
                    </div>
                  </div>
                </div>
                <div class="message-list-item-content" v-else>
                  <div>
                    <div>
                      {{item.code == 2602 ?  item.information.extra:''}}
                    </div>
                    <div>
                      {{$t('information._'+item.code)}}
                    </div>
                  </div>


                  <!--{{$t('information._'+item.code)}}-->
                </div>
              </div>
            </transition-group>



          </div>
          <div class="message-bottom">
            <!--<router-link to="/information">-->
            <a @click="viewAllClick">{{$t('information.viewALLMessages')}}</a>
            <!--</router-link>-->

          </div>
        </div>
        <!--<svg-icon v-if="badgeNub == 0 "  class-name='left-menu-logo ' :class="badgeNub == 0 ? '':'bell'"  />-->

        <el-badge  :value="badgeNub" :max="99" class="badgeItem" slot="reference">
          <svg-icon icon-class="message"  class-name='left-menu-logo '  :class="badgeNub == 0 ? '':'bell'" />
        </el-badge>



        <!--<el-button >click 激活</el-button>-->
      </el-popover>
    </div>
    <div class="right-menu">
      <dashboard v-show="dashboardShow == 0 ? false: true"></dashboard>
      <!--<el-divider direction="vertical" style="margin-right: -15px"></el-divider>-->
      <div style="width: 1px;height: 15px; background: #fff;margin-left: 10px;margin-right: 1px" class="vertical" v-show="dashboardShow == 0 ? false: true"></div>
      <language ></language>
      <!--<el-divider direction="vertical"></el-divider>-->
      <div style="width: 1px;height: 15px; background: #fff;margin-left: 10px;margin-right: 7px"></div>
      <!--<el-dropdown class="avatar-container right-menu-item" trigger="click" >-->
      <!--<div class="avatar-wrapper">-->
      <!--<div  >-->
      <!--<img class="user-avatar" :src="avatar+'?imageView2/1/w/80/h/80'">-->
      <!--<i class="el-icon-caret-bottom" ></i>-->
      <!--</div>-->
      <!--</div>-->

      <!--<el-dropdown-menu slot="dropdown">-->

      <!--<el-dropdown-item :command="commandOne">生日当天发送</el-dropdown-item>-->

      <!--<el-dropdown-item :command="commandTwo">生日前一天发送</el-dropdown-item>-->

      <!--<el-dropdown-item :command="commandThr">生日前一星期发送</el-dropdown-item>-->

      <!--</el-dropdown-menu>-->


      <!--</el-dropdown>-->
      <div class="avatar-container right-menu-item">
        <el-popover
          placement="bottom"
          width="186"
          trigger="hover"
          popper-class="popperClass5"
        >
          <el-dropdown-item>
            <div class="my-name">
              <div class="my-name-data">
                {{userName}}
              </div>
              <div class="my-name-orger">
                {{endOrgName}}
              </div>
            </div>

          </el-dropdown-item>
          <router-link to="/user">
            <el-dropdown-item v-if="userStatus == 1 ? false:true">
              <div class="oprofile" @click="oprofileClick">
                {{$t('navbar.oprofile')}}
              </div>
            </el-dropdown-item>
          </router-link>
          <router-link to="/updates">
            <el-dropdown-item v-if="userStatus == 1 ? false:true">
              <div class="oprofile">
                {{$t('navbar.updates')}}
              </div>
            </el-dropdown-item>
          </router-link>
          <router-link to="/guidepages" :title='$t("navbar.newUserGuide")'>
            <el-dropdown-item v-if="userStatus == 1 ? false:true">
              <div class="oprofile" style="width: 80%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                {{$t('navbar.newUserGuide')}}
              </div>
            </el-dropdown-item>
          </router-link>
            <el-dropdown-item v-if="isPublicCloud == false ? false : userStatus == 1 ? false:true">
            <div  class="oprofile" @click="$emit('handleFeedback')">
              {{$t('feedback.Feedback')}}
            </div>
          </el-dropdown-item>
          <el-dropdown-item v-if="userStatus == 1 ? false:true">
            <div  class="logout" @click="logout">
              {{$t('navbar.logOut')}}
            </div>
          </el-dropdown-item>
          <el-dropdown-item v-if="userStatus == 1 ? true:false">
            <div class="logout" @click="BackClick">
              {{$t('navbar.BackTianwa')}}
            </div>
          </el-dropdown-item>
          <div class="avatar-wrapper" slot="reference">
            <div  >
              <img class="user-avatar" :src="avatar+'?imageView2/1/w/80/h/80'">
              <i class="el-icon-caret-bottom" ></i>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
  </el-menu>

  <!--</div>-->
</template>

<script>
  import { mapGetters } from 'vuex'
  // import Hamburger from '@/components/Hamburger'
  import ErrorLog from '@/components/ErrorLog'
  import Screenfull from '@/components/Screenfull'
  import LangSelect from '@/components/LangSelect'
  import ThemePicker from '@/components/ThemePicker'
  import Sidebar from './Sidebar'
  import Dashboard from './Dashboard'
  import Language from  './Language'
  import ElCheckbox from "element-ui/packages/checkbox/src/checkbox"
  import {selectEquipmentInfoNum, selectEquipmentInfoList,updateEquipmentInfoState} from  '@/api/information'
  import {getPublicCloud} from "../../../api/common";
  // import {Sidebar} from '@/components/Sidebar'
  export default {
    data() {
      let _this = this
      return {
        isPublicCloud:true,
        langType: false,
        visible:false,
        messageVisible:false,
        badgeNub:0,
        equipmentInfoList:[],
        allCheckd:false,
        messageActive:11,
        dashboardShow:_this.$store.state.user.isManage,
        currentIndex:'',
        userName:'',
        endOrgName:'',
        userStatus:_this.$store.state.user.userStatus
      }
    },
    components: {
      // Hamburger,
      ElCheckbox,
      ErrorLog,
      Screenfull,
      LangSelect,
      ThemePicker,
      Sidebar,
      Dashboard,
      Language
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'name',
        'avatar'
      ]),
      language() {
        return this.$store.getters.language
      },
      messageType(){
        //消息页面修改导航消息数据跟着修改
        return this.$store.state.user.messageType
      }
    },
    watch:{
      //消息页面修改导航消息数据跟着修改
      messageType:function(old,newd){
        //获取未读消息通知个数
        this.selectEquipmentInfoNum()
        //
        this.selectEquipmentInfoList()
        // this.getEchart(0)
      }
    },
    created() {
      this.getPublicCloud()
      this.selectUserBindRoleByUserId()
      //获取未读消息通知个数
      this.selectEquipmentInfoNum()
      //
      this.selectEquipmentInfoList()
      this.$store.commit('SET_MESSAGETYPE','')
      if(this.$store.getters.userName == undefined || this.$store.getters.userName == ""){
        this.userName = ""
      }else {
        this.userName = this.$store.getters.userName
      }
      if(this.$store.getters.endOrgName == undefined || this.$store.getters.endOrgName == ""){
        this.endOrgName = ""
      }else {
        this.endOrgName = this.$store.getters.endOrgName
      }

    },
    methods: {
      //3.1.12 获取工程私有云设置
      async getPublicCloud(){
        // 判断是否公有云，私有云就显示上传按钮
        try {
          let data = await getPublicCloud()
          this.isPublicCloud = data.jsonBody.msgBody.isPublicCloud ==  'false'  ? false : true
        }catch (e) {
          // console.log('e',e);
        }finally {

        }
      },
      BackClick(){
        if(this.$store.state.user.thirdUrl == undefined){
          window.location.href = 'https://www.tianwayun.com/'
        }else {
          window.location.href= this.$store.state.user.thirdUrl
        }

      },
      codeClick(){
        window.location.href="/dashboard/repairLog"
      },
      messageClick(data, index){
        if(!data.checkd){
          data.checkd = true
          this.checkboxChange(1,data)
          // this.messageActive = index
        }
        this.currentIndex = data.id
        // this.show+index = false
      },
      checkboxChange(type,data){
        if(type == 1){
          if(data.checkd){
            this.updateEquipmentInfoState(type,data)

          }
        }else {

          this.equipmentInfoList.forEach(function (item,i) {
            item.checkd = true
          })
          let equipmentInfoId = new Array()
          // this.equipmentInfoList.forEach(function (item,i) {
          //   equipmentInfoId.push(item.id)
          // })
          if(this.allCheckd){
            this.$EventBus.$emit('updateDetailsPage')
            this.updateEquipmentInfoState(type,equipmentInfoId)
          }

        }

      },
      //4.1.2 修改消息通知状态
      updateEquipmentInfoState(type,data){
        let param1 = new Object()
        let param = new Object()
        let infoIdList = new Array()
        let _this = this
        if(type == 1){
          param1.isCheckAll = false
          infoIdList.push(data.id)
        }else {
          param1.isCheckAll = true
          infoIdList = data
        }
        param1.infoIdList = infoIdList
        param1.isRead = 1
        param.jsonBody = param1
        this.loading = true
        return new Promise((resolve, reject) => {
          updateEquipmentInfoState(param).then(res => {
            let jsonBodyData = res.jsonBody
            let rtnCode = jsonBodyData.rtnCode
            if (rtnCode == 0) {
              if(_this.allCheckd){
                _this.allCheckd = false
              }
              this.selectEquipmentInfoNum()
              this.selectEquipmentInfoList()

            }
            // resolve(true)
          }).catch(err => {
            _this.$message({
              message: '修改失败！',
              type: 'warning',
              duration: 1000
            });
            // reject(false)
          })
        })
      },
      //获取未读消息通知个数
      selectEquipmentInfoNum(){
        let param1 = new Object()
        let param = new Object()
        let _this = this
        return new Promise((resolve, reject) => {
          selectEquipmentInfoNum({}).then(res => {
            let jsonBodyData = res.jsonBody
            let rtnCode = jsonBodyData.rtnCode
            if (rtnCode == 0) {
              _this.badgeNub = jsonBodyData.msgBody.equipmentInfoNum
            }
            // resolve(true)
          }).catch(err => {
            // _this.$message({
            //   message: '修改失败！',
            //   type: 'success',
            //   duration: 1000
            // });
            // reject(false)
          })
        })
      },
      selectEquipmentInfoList(){
        let param1 = new Object()
        let param = new Object()
        let _this = this
        param1.isRead = 0
        param1.pageNum = 1
        param1.pageSize = 10
        param1.sortType = 0
        param.jsonBody = param1
        return new Promise((resolve, reject) => {
          selectEquipmentInfoList(param).then(res => {
            let jsonBodyData = res.jsonBody
            let rtnCode = jsonBodyData.rtnCode
            if (rtnCode == 0) {
              jsonBodyData.msgBody.rows.forEach(function (item,i) {
                item.checkd = false
              })
              _this.equipmentInfoList = jsonBodyData.msgBody.rows
            }
            // resolve(true)
          }).catch(err => {
            // _this.$message({
            //   message: '修改失败！',
            //   type: 'success',
            //   duration: 1000
            // });
            // reject(false)
          })
        })
      },
      viewAllClick(){
        this.messageVisible = false
        this.$router.push("/information")
      },
      handleSetLanguage(lang) {
        this.$i18n.locale = lang
        this.$store.dispatch('setLanguage', lang)
        this.$store.dispatch('setLanguage', lang)
        if(lang == "zh"){
          document.title = 'Q-NEX 工作台'
        }else if(lang == "en"){
          document.title = 'Q-NEX Console'
        }
        if(lang == "zh"){
          this.moment.locale('zh-cn');
        }else if(lang == "en"){
          this.moment.locale('en-gb');
        }
        // this.$message({
        //   message: 'switch language success',
        //   type: 'success'
        // })
        this.$router.push("/")
        // let   integrityurl = window.location.host + window.location.pathname
        // window.location.href = integrityurl
        // this.$router.go(0)
      },
      oprofileClick(){
        // this.$router.push({name: 'user'})
      },
      homeClick(){
        this.$router.push("/")
      },
      toggleSideBar() {
        this.$store.dispatch('toggleSideBar')
      },

      selectUserBindRoleByUserId(){

      },

      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload()// In order to re-instantiate the vue-router object to avoid bugs
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .navbar {
    height: 88px;
    line-height: 88px;
    background: -webkit-linear-gradient(#11B9FF, #1E8DFF); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(#11B9FF, #1E8DFF); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(#11B9FF, #1E8DFF); /* Firefox 3.6 - 15 */
    background: linear-gradient(#11B9FF, #1E8DFF); /* 标准的语法 */
    background-color: #2D3A4B;
    .hamburger-container {
      line-height: 58px;
      height: 50px;
      float: left;
      padding: 0 10px;
    }
    .breadcrumb-container{
      float: left;
    }
    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }
    .left-menu{
      float: left;
      height: 100%;
      .left-menu-container{
        fill: #ffffff;
        float: left;
        margin: 0px 20px;
        .hamburger{
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
      }
      .left-menu-logo{
        width: 150px;
        height: 100px;
        margin-top: -4px;
      }
    }
    .right-menu {
      float: right;
      height: 100%;
      margin-right: 30px;
      display: flex;
      align-items: center;
      &:focus{
        outline: none;
      }
      .right-menu-item {
        display: inline-block;
        /*margin: 0 8px;*/
      }
      .screenfull {
        height: 20px;
      }
      .international{
        vertical-align: top;
      }
      .theme-switch {
        vertical-align: 15px;
      }
      .avatar-container {
        height: 50px;
        margin-right: 30px;
        .avatar-wrapper {
          cursor: pointer;
          margin-top: -7px;
          position: relative;
          height: 100%;
          .el-popover__reference{
            height: 100%;
          }
          .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
          .el-icon-caret-bottom {
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
  .left-menu-logo{
    font-size: 24px;
    color: #fff;
    margin-left: 20px;
    margin-top: 40px;
  }
  .el-icon-control-lang{
    font-size: 12px;
    margin-left: -17px;
  }
  .mark-message{
    .mark-message-title{
      height: 50px;
      line-height: 50px;
      text-align: right;
      margin-right: 40px;
    }
    .message-list{
      padding: 0px 20px;
      max-height: 430px;
      overflow-y: auto;
      overflow-x: hidden;
      .message-list-item-active{
        background:linear-gradient(0deg,rgba(28,149,255,1),rgba(19,179,255,1));
        .message-list-item-content{
          display: flex;
          align-items: center;
          justify-content:flex-start;
          width: 220px;
          font-size:14px;
          font-weight:400;
          color:rgba(255,255,255,1);
        }
      }
      .message-list-item{
        display: flex;
        height:60px;
        border:1px solid rgba(204,204,204,1);
        border-radius:8px;
        margin-top: 10px;
        cursor: pointer;
        .message-list-item-cox{
          width: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .message-list-item-content{
          display: flex;
          align-items: center;
          justify-content:flex-start;
          width: 220px;
          font-size:14px;
          font-weight:400;
          color:#000;
        }
      }
    }
    .message-bottom{
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size:14px;
      font-family:inter;
      font-weight:400;
      color:rgba(23,165,255,1);
      a{
        text-decoration:underline;
        cursor: pointer;
      }
    }
  }
  .my-name{
    margin: 0 20px;
    margin-top: 5px;
    border-bottom: 1px solid rgba(228,231,237,1);
    .my-name-data{
      font-weight:700;
      color:rgba(179,179,180,1);
      min-height:16px;
      line-height:16px;
    }
    .my-name-orger{
      font-weight:400;
      color:#B3B3B4;
      font-size:12px;
      height:30px;
      line-height:28px;
      width: 146px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .oprofile{
    margin: 0 20px;
    /*margin-top: 6px;*/
    color: #606266;
    font-weight:400;
    font-size:14px;
  }
  .logout{
    margin: 0 20px;
    margin-bottom: -3px;
    color: #606266;
    font-weight:400;
    font-size:14px;
  }

  .bell{-webkit-animation:bellshake 2s ease-out infinite;animation:bellshake 2s ease-out infinite;-webkit-transform-origin:center top;transform-origin:center top}
  @-webkit-keyframes bellshake{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}3.75%{-webkit-transform:rotate(25deg);transform:rotate(25deg)}15%{-webkit-transform:rotate(-25deg);transform:rotate(-25deg)}22.5%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}29%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}35%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}43%{-webkit-transform:rotate(-2deg);transform:rotate(-2deg)}50%,to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}@keyframes bellshake{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}3.75%{-webkit-transform:rotate(25deg);transform:rotate(25deg)}15%{-webkit-transform:rotate(-25deg);transform:rotate(-25deg)}22.5%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}29%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}35%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}43%{-webkit-transform:rotate(-2deg);transform:rotate(-2deg)}50%,to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/LogoView.vue